import {Close} from '@material-ui/icons';
import {Language} from '../../../context/LanguageContext';
import Cookies from 'js-cookie';
// import nookies from 'nookies';
import {Switch} from '@material-ui/core';
import {styled, TextField} from '@mui/material';
import {useCallback, useEffect, useState} from 'react';
import {useUser} from '../../../hooks';
import {GROUP_ACCESS_LIST} from '../../../consts/common';

export default function FormGroup({type, onClose, data}) {
  const tokens_session = Cookies.get('token');
  const {language, newObj} = Language();
  const {createUserGroup, updateUserGroup} = useUser();
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    id: '',
    name: '',
    description: '',
    authority: [],
  });
  const MaterialUISwitch = styled(Switch)(({checked}) => ({
    '& .MuiSwitch-thumb': {
      color: checked ? '#68aaff !important' : 'dimgray',
    },
    '& .Mui-checked': {
      color: checked ? '#5a7ba6 !important' : 'dimgray',
    },
    '& .MuiSwitch-track': {
      backgroundColor: checked ? '#5a7ba6 !important' : 'dimgray',
    },
  }));
  const handleChangeInput = (e) => {
    const {name, value} = e.target;
    setPayload((prev) => ({...prev, [name]: value}));
  };
  const handleChangeCheck = (e) => {
    const {name, value, checked} = e.target;
    if (checked) {
      setPayload((prev) => ({...prev, [name]: [...prev[name], value]}));
    } else {
      setPayload((prev) => ({
        ...prev,
        [name]: prev[name].filter((item) => item !== value),
      }));
    }
  };

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        setLoading(true);
        if (type === 'add') await createUserGroup(tokens_session, payload);
        else
          await updateUserGroup(tokens_session, {
            ...payload,
            language: language == 1 ? 'en' : 'my',
          });
      } catch (error) {
      } finally {
        setLoading(false);
        onClose();
      }
    },
    [tokens_session, payload, type, language]
  );

  useEffect(() => {
    if (data?.selected)
      setPayload((prev) => ({
        ...prev,
        id: data.selected.id,
        name: data.selected.name,
        description: data.selected.description,
        authority: data.selected.authority,
      }));
  }, [data?.selected]);

  return (
    <div className='modal_content center add_new_user'>
      <div className='modal_header'>
        <p className='modal_title'>{newObj.GroupWord[language]}</p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <form action='POST' className='modal_body' onSubmit={handleSubmit}>
        <div className='left'>
          <div className='profile_input'>
            <TextField
              className='item'
              type='text'
              variant='outlined'
              label='Group Name'
              name='name'
              onChange={handleChangeInput}
              value={payload.name}
            />
            <TextField
              className='item multiline'
              type='text'
              variant='outlined'
              label='Group Description'
              name='description'
              onChange={handleChangeInput}
              value={payload.description}
              multiline
              rows={4}
            />
          </div>
        </div>
        <div className='right'>
          <div className='banner_assign_group'>
            <p>{newObj.AdminAccessWord[language]}</p>
          </div>
          <div className='list_group_choice'>
            {GROUP_ACCESS_LIST.map((access) => (
              <div className='item_group authority' key={access.value}>
                <MaterialUISwitch
                  id={access.value}
                  onChange={handleChangeCheck}
                  checked={payload?.authority?.includes(access.value)}
                  value={access.value}
                  name='authority'
                />
                <label htmlFor={access.value}>{access.label}</label>
              </div>
            ))}
          </div>
          <div className='modal_flexible_btn_ctr'>
            <button type='submit' disabled={loading}>
              {newObj.SaveWord[language]}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
